import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from './core/guards/auth.gaurds';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found/page-not-found.component';
import { BankAccountFormComponent } from './shared/components/bank-account-form/bank-account-form.component';
import { AccountSettingComponent } from './shared/components/account-setting/account-setting.component';

const routes: Routes = [
  // Phone pages opened from the wallet-charge QR code: public, the session token is the credential.
  {
    path: 'mobile-charge',
    loadComponent: () =>
      import('./features/Borrower/mobile-charge/mobile-charge.component').then((m) => m.MobileChargeComponent),
  },
  {
    path: 'mobile-charge-complete',
    loadComponent: () =>
      import('./features/Borrower/mobile-charge/mobile-charge-complete.component').then((m) => m.MobileChargeCompleteComponent),
  },
  // {
  //   path: '',
  //   redirectTo: '/users',
  //   pathMatch: 'full',
  // },

  {
    path: 'confirm-email',
    loadComponent: () =>
      import('./features/confirm-email/confirm-email.component').then((m) => m.ConfirmEmailComponent),
  },
  // Investor portal: kept outside the borrower/supplier layout (see InvestorLayoutComponent).
  {
    path: 'Investor',
    canActivate: [AuthenticationGuard],
    loadComponent: () =>
      import('./features/investor/investor-layout/investor-layout.component').then((m) => m.InvestorLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'Dashboard' },
      {
        path: 'Dashboard',
        loadComponent: () =>
          import('./features/investor/investor-dashboard/investor-dashboard.component').then(
            (m) => m.InvestorDashboardComponent
          ),
      },
      {
        path: 'Opportunities/:opportunityId',
        loadComponent: () =>
          import('./features/investor/opportunity-details/opportunity-details.component').then(
            (m) => m.OpportunityDetailsComponent
          ),
      },
      {
        path: 'MyInvestments',
        loadComponent: () =>
          import('./features/investor/my-investments/my-investments.component').then((m) => m.MyInvestmentsComponent),
      },
      {
        path: 'Wallet',
        loadComponent: () =>
          import('./features/investor/investor-wallet/investor-wallet.component').then((m) => m.InvestorWalletComponent),
      },
      {
        path: 'wallet-payment-notify',
        loadComponent: () =>
          import('./features/Borrower/wallet/wallet-payment-notify.component').then((m) => m.WalletPaymentNotifyComponent),
      },
      {
        path: 'MyInvestments/:opportunityId',
        loadComponent: () =>
          import('./features/investor/my-investments/investment-details/investment-details.component').then(
            (m) => m.InvestmentDetailsComponent
          ),
      },
      {
        path: 'Profile',
        loadComponent: () =>
          import('./features/investor/investor-profile/investor-profile.component').then(
            (m) => m.InvestorProfileComponent
          ),
      },
      {
        path: 'kyc-questions',
        loadComponent: () =>
          import('./features/investor/investor-profile/kyc-tab/kyc-questions-wizard/kyc-questions-wizard.component').then(
            (m) => m.KycQuestionsWizardComponent
          ),
      },
      {
        path: 'upgrade-account',
        loadComponent: () =>
          import('./features/investor/investor-profile/kyc-tab/upgrade-account/upgrade-account.component').then(
            (m) => m.UpgradeAccountComponent
          ),
      },
      {
        path: 'bank-accounts/add',
        component: BankAccountFormComponent,
      },
    ],
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/view/view.module').then((m) => m.ViewModule),
  },
  {
    path: 'authentication',
    loadChildren: () =>
      import('./features/authentication/auth.module').then((m) => m.AuthModule),
  },


  // {
  //   path: 'Borrower',
  //   loadChildren: () =>
  //     import('./features/Borrower/borrower.module').then(
  //       (m) => m.BorrowerModule
  //     ),
  //   canActivate: [AuthenticationGuard],
  // },
  // {
  //   path: 'Supplier',
  //   loadChildren: () =>
  //     import('./features/supplier/supplier.module').then(
  //       (m) => m.SupplierModule
  //     ),
  //   canActivate: [AuthenticationGuard],
  // },
  // {
  //   path: ':role/bank-accounts/add',
  //   component: BankAccountFormComponent,
  //   canActivate: [AuthenticationGuard],
  // },
  // {
  //   path: ':role/bank-accounts/edit/:id',
  //   component: BankAccountFormComponent,
  //   canActivate: [AuthenticationGuard],
  // },
  // {
  //   path: ':role/account-setting',
  //   component: AccountSettingComponent,
  //   canActivate: [AuthenticationGuard],
  // },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      useHash: true,

    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
